import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchSecurityExclusion } from './thunks';
import { ReportSettingsState, SecurityExclusion } from './types';

export const initialState: ReportSettingsState = {
  securityExclusions: [],
};

export const reportSettingsSlice = createSlice({
  name: 'reportSettingsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSecurityExclusion.fulfilled, (state: ReportSettingsState, action: PayloadAction<SecurityExclusion[]>) => {
      state.securityExclusions = action.payload;
    });
  },
});
